import React, {useState, useEffect} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';


export default function LinkRow({id, title, description, clickFunction, index, isBig}){
	
	const [defaultBackground, setDefaultBackground] = useState("white");
	const [thisBackground, setThisBackground] = useState("white");
	const [thisForeground, setThisForeground] = useState("black");
	const [thisIconColor, setThisIconColor] = useState(DEFAULT_BLUE);
	const [thisHeight, setThisHeight] = useState("30px")
	
	useEffect(() => {
		
		if(isBig && isBig.length > 0){
			setThisHeight("60px");
		}
		
		if(index%2 === 0){
			setDefaultBackground("#eee");
			setThisBackground("#eee");
		}
		else{
			setDefaultBackground("white");
			setThisBackground("white");
		}
	}, [index, id, thisHeight]);
	
	const handleClick = () => {
		clickFunction(id);
	};
	
	const handleMouseOver = () => {
		setThisBackground(DEFAULT_BLUE);
		setThisIconColor("white");
		setThisForeground("white");
	};
	
	const handleMouseOut = () => {
		setThisBackground(defaultBackground);
		setThisIconColor(DEFAULT_BLUE);
		setThisForeground("black");
	};
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		height:thisHeight,
		alignItems:"center",
		borderRadius:"4px",
		background:thisBackground,
		cursor:"pointer"
	};
	
	const iconStyle = {
		display:"flex",
		margin:"10px",
		height:"15px",
		width:"15px",
		color:thisIconColor
	};
	
	const titleText = {
		display:"flex",
		width:"300px",
		fontSize:"14px",
		color:thisForeground
	};
	
	const descriptionText = {
		display:"flex",
		width:"calc(100% - 340px)",
		fontSize:"12px",
		color:thisForeground
	};
	
	return (
		<div style={thisContainer} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onClick={handleClick}>	
				<FontAwesomeIcon icon="angle-right" style={iconStyle}/>
				<div style={titleText}>
					{title}
				</div>
				<div style={descriptionText}>
					{description}
				</div>
		</div>
		
	);
}